import React, {Component} from 'react';

import PropTypes from 'prop-types';
import TableComponentEnum from './../../utils/TableComponentEnum';

class TableRowColumn extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {

  };

  render() {
    const {
      children,
      onClick, // eslint-disable-line no-unused-vars
    } = this.props;

      let tSearchHead;
      let tBody;
      let tHead;
      let tPagination;

      React.Children.forEach(children, (child) => {
          const comType = child.type;
          if (comType.componentType === TableComponentEnum.TABLEBODY) {
              tBody = child;
          } else if (comType.componentType === TableComponentEnum.TABLESEARCHHEADER) {
              tSearchHead = child;
          } else if (comType.componentType === TableComponentEnum.TABLEHEAD) {
              tHead = child;
          } else if (comType.componentType === TableComponentEnum.TABLEPAGINATION) {
              tPagination = child;
          } else {
              console.log("Child is not found");
          }
      });

      return <div className = "row">
          <div className = "col-md-12">
              <div className = "portlet box blue-hoki">
                  { tSearchHead }
                  <div className="portlet-body">
                      <table className="table table-striped table-bordered table-hover">
                          { tHead }
                          { tBody }
                      </table>
                      { tPagination }
                  </div>
              </div>
          </div>
      </div>;
  }
}

export default TableRowColumn;